import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "aria-label"]
const _hoisted_2 = ["src", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["audio-player", {'audio-player--compact': _ctx.compact}])
  }, [
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("audio", {
          key: 0,
          ref: "audio",
          src: _ctx.src,
          "aria-label": _ctx.label,
          controls: "",
          preload: "metadata",
          class: "audio-player-native",
          onPlay: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNativePlay && _ctx.onNativePlay(...args))),
          onEnded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.playing = false)),
          onPause: _cache[2] || (_cache[2] = ($event: any) => (_ctx.playing = false))
        }, null, 40, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_v_btn, {
            variant: "text",
            icon: "",
            size: "x-small",
            class: "no-drag",
            title: _ctx.actionLabel,
            "aria-label": _ctx.actionLabel,
            onClick: _withModifiers(_ctx.toggle, ["stop","prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.playing ? 'mdi-pause' : 'mdi-play'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "aria-label", "onClick"]),
          _createElementVNode("audio", {
            ref: "audio",
            src: _ctx.src,
            "aria-label": _ctx.label,
            preload: "none",
            onEnded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.playing = false)),
            onPause: _cache[4] || (_cache[4] = ($event: any) => (_ctx.playing = false)),
            onPlay: _cache[5] || (_cache[5] = ($event: any) => (_ctx.playing = true))
          }, null, 40, _hoisted_2)
        ], 64))
  ], 2))
}